/**
 * Created by Ibrahim Erata on 09.03.2017.
 */

import {Injectable, Inject} from '@angular/core';
import {Router} from '@angular/router';
import {TranslateService} from "@ngx-translate/core";
import {Config} from "../../../environments/environment";
import Swal, { SweetAlertIcon } from 'sweetalert2';
import {PdfViewerControlService} from './PdfViewerControl.service';
import { HttpErrorResponse } from '@angular/common/http';

declare var $:any;
declare var jGrowl:any;

@Injectable()
export class NotificationService {

  swalOptions:any = {
    "type": "warning",
    "showCancelButton":true,
    "confirmButtonClass": "btn-primary",
    "confirmButtonText": "Ok",
    "cancelButtonText": "No",
    "customClass": {
      "popup": "swal-custom-popup",
      "icon": "swal-custom-icon"
    }
  };


  constructor( private router: Router, private translate: TranslateService, private pdfViewerControl: PdfViewerControlService ){ }

  errorOccuredInServer(){
    this.showAnErrorOccuredInServer(function(isConfirmed:boolean) {
      if(isConfirmed) {
        setTimeout(() => { location.reload(); }, 0);
      }
    });
  }

  serverNotReachable(){
    this.showServerNotReachable(function(isConfirmed:boolean) {
      if(isConfirmed) {
        setTimeout(() => { location.reload(); }, 0);
      }
    });
  }

  //---MAIN FONCTIONS ---

  private Notification(message: string, subTheme:string, sticky?:boolean){
    this.sendMessageToParent(subTheme, message);
    $.jGrowl(message, {
      position: 'top-right',
      theme: 'alert-bordered alert-styled-left ' + subTheme,
      animateClose: 'fadeOut',
      //header: 'The Result',
      sticky: sticky || false,
      html:true
    });
  }

  displayError(error: HttpErrorResponse | any){
    let errMsg:string = "";
    let errCode:number;
    let errorJson:any;

    try {
      if (error instanceof HttpErrorResponse) {
        errorJson = error.error;
        if(errorJson.code instanceof Number){
          errCode = errorJson.code;
        } else {
          errCode = parseInt(errorJson.code);
        }
        errMsg = errorJson.description || "";
      } else {
        errMsg = error.description ? error.description : "";
        if (errMsg == "" ) {
          errMsg = error.message ? error.message : error.toString();
        }
        errCode = error.code ? error.code : null;
      }
    } catch (catchError) {
      try {
        let body = JSON.parse(error._body);
        if(body.code instanceof Number){
          errCode = errorJson.code;
        } else {
          errCode = parseInt(errorJson.code);
        }
        errMsg = body.description || "";
      } catch (catchError) {
        try {
          let arrayBuffer:ArrayBuffer = error._body;
          var enc = new TextDecoder("utf-8");
          var arr = new Uint8Array(arrayBuffer);
          let errorJsonString = JSON.parse(enc.decode(arr));
          errCode = errorJsonString.code;
          errMsg = errorJsonString.description;
        } catch (error) {
          console.error(error);
        }
      }
    }

    if(errCode){
      switch (errCode) {
        // 203: INVALID_INPUT
        case 203:
          this.invalidInput();
          return;

        // 304: TIMESTAMP_SERVICE_UNAVAILABLE (TSA/TSS unreachable during signing)
        // 304 is the backend-assigned value and is fixed; 303 is already allocated to
        // the signer-placed signature box failure.
        case 304:
          this.timestampServiceUnavailable();
          return;

        // 206: INTERNAL_SERVER_ERROR
        case 206:
          this.internalServerError();
          return;

        // 210: NO_USER_EXIST
        case 210:
          this.userNotFound();
          return;

        // 213: NOT_OWNER
        case 213:
          this.notOwner();
          return;

        // 214: INVALID_CREDENTIALS
        case 214:
          this.showInvalidCredentialsForLoginAlert();
          return;

        // 215: PDF_NOT_APPLICABLE_FOR_SIGNING
        case 215:
          this.pdfNotApplicableForSigning();
          return;

        // 216: NO_DOCUMENT
        case 216:
          this.documentNotFound();
          return;

        // 217: CANT_COPY_DOCUMENTS
        case 217:
          this.cantCopyDocuments();
          return;

        // 218: INVALID_JOB
        case 218:
          this.invalidJobIdentifier();
          return;

        // 219: NO_RECIPIENT_REQUEST
        case 219:
          this.noRecipientRequest();
          return;

        // 220: CAN_NOT_DELETE_OWNER_RECIPIENT
        case 220:
          this.cannotDeleteOwnerRecipient();
          return;

        // 221: RECIPIENT_ALREADY_EXIST
        case 221:
          this.recipientAlreadyExists();
          return;

        // 222: REQUEST_CODE_ALREADY_USED
        case 222:
          this.showRequestCodeAlreadyUsed(errMsg, function() {});
          return;

        // 223: NOT_SUITABLE_MEMBERSHIP_PLAN
        case 223:
          this.membershipPlanNotSuitable();
          return;

        // 224: CAN_NOT_CONNECT_MOBILE_SIGNING_SERVER
        case 224:
          this.signingMobileSignNotFound();
          return;

        // 225: SUSPENDED_SUBSCRIPTION
        case 225:
          this.SuspendedSubscription();
          return;

        // 226: SIGNATURE_TIMESTAMP_NOT_VERIFIED
        case 226:
          this.signatureTimestampNotVerified();
          return;

        // 227: LAST_SIGNATURE_IS_TIMESTAMP
        case 227:
          this.lastSignatureIsTimestamp();
          return;

        // 228: ALREADY_MOVED_TO_INBOX
        case 228:
          this.alreadyMovedToInbox();
          return;

        // 229: ALREADY_MOVED_TO_ARCHIVE
        case 229:
          this.alreadyMovedToArchive();
          return;

        // 230: ALREADY_ASSOCIATED
        case 230:
          this.emailAlreadyAssociated();
          return;

        // 231: ASSOCIATED_EMAIL_WAITING_APPROVAL
        case 231:
          this.emailAssociationWaitingApproval();
          return;

        // 232: INVALID_OR_NONEXISTENT_ACCESSCODE
        case 232:
          this.invalidAccessCode();
          return;

        // 233: NO_PUBLIC_LINK
        case 233:
          this.publicLinkNotExist();
          return;

        // 234: INVALID_PARAMETER_SORTING
        case 234:
          this.invalidParameterSorting();
          return;

        // 235: LESS_THAN_SIX_HOURS
        case 235:
          this.lessThanSixHours();
          return;

        // 236: QUOTA_IS_FULL
        case 236:
          this.showAccountReachedMaxSignatureLimit(null);
          return;

        // 237: MONTHLY_USAGE_EXPIRED
        case 237:
          this.showQuotaFull(0, 0, null);
          return;

        // 238: COUPON_USAGE_EXPIRED
        case 238:
          this.couponUsageExpired();
          return;

        // 239: MOBILE_CERTIFICATE_CHANGED
        case 239:
          this.mobileCertificateChanged();
          return;

        // 240: SIGNING_BUSSY
        case 240:
          this.signingBusy();
          return;

        // 241: SIGNING_EXPIRED
        case 241:
          this.signingExpired();
          return;

        // 242: COUPON_DISCOUNT_EXPIRED
        case 242:
          this.couponDiscountExpired();
          return;

        // 243: WAIT_TO_COMPLETE_OF_JOB_FOR_ACCESSCODE
        case 243:
          this.waitToCompleteJobForAccesscode();
          return;

        // 244: JOB_STATE_NOT_SUITABLE
        case 244:
          this.jobStateNotSuitable();
          return;

        // 245: NO_API_USER_RIGHTS
        case 245:
          this.noApiUsageRights();
          return;

        // 246: DOCUMENT_ALREADY_SIGNED
        case 246:
          this.documentAlreadySigned();
          return;

        // 247: MOBILE_TOKEN_TIMEOUT
        case 247:
          this.mobileTokenTimeout();
          return;

        // 248: JOB_TYPE_NOT_NONE
        case 248:
          this.showTemplateErrorMultipleJobNotNone(null);
          return;

        // 249: TEMPLATE_PAGE_SIZE_ERROR
        case 249:
          this.showTemplateError(null);
          return;

        // 250: JOB_NOT_EXIST
        case 250:
          this.jobNotFound();
          return;

        // 251: SFTP_NOT_EXIST
        case 251:
          this.sftpNotExist();
          return;

        // 252: SFTP_CREDENTIALS_WRONG
        case 252:
          this.sftpCredentialsWrong();
          return;

        // 253: SFTP_SERVER_PROBLEM
        case 253:
          this.sftpServerProblem();
          return;

        // 254: EMPTY_ADDRESS_BOOK
        case 254:
          this.addressBookIsEmpty();
          return;

        // 255: NO_USER_FOUND_FOR_TEAM_MEMBER
        case 255:
          this.showNoUserFoundAlert();
          return;

        // 256: MEMBER_ALREADY_IN_TEAM
        case 256:
          this.showUserAlreadyInTeam();
          return;

        // 257: TEAM_REQUEST_CANCELLED
        case 257:
          this.teamRequestCancelled();
          return;

        // 258: TEAM_REQUEST_CODE_USED
        case 258:
          this.teamRequestCodeUsed();
          return;

        // 259: NO_PERMISSION
        case 259:
          this.noPermission();
          return;

        // 260: RECIPIENT_NOT_MATCH
        case 260:
          this.recipientNotMatch();
          return;

        // 261: TEAM_MEMBER_QUOTA_FULL
        case 261:
          this.teamMemberQuotaFull();
          return;

        // 262: NO_RECIPIENT_FOUND
        case 262:
          this.noRecipientExist();
          return;

        // 263: SMS_OTP_EXPIRED
        case 263:
          this.smsOtpExpired();
          return;

        // 264: SMS_OTP_DOES_NOT_MATCH
        case 264:
          this.smsOtpDoesNotMatch();
          return;

        // 265: SMS_QUOTA_IS_FULL
        case 265:
          this.smsQuotaIsFull();
          return;

        // 266: PAYMENT_NOT_FOUND
        case 266:
          this.paymentNotFound();
          return;

        // 267: FILE_NAME_TOO_LONG
        case 267:
          this.fileNameTooLong();
          return;

        // 268: CERTIFICATE_EXPIRING_SOON
        case 268:
          this.certificateExpiringSoon();
          return;

        // 269: INVALID_USER_GROUP
        case 269:
          this.invalidUserGroup();
          return;

        // 270: RESET_CODE_NOT_FOUND
        case 270:
          this.resetCodeNotFound();
          return;

        // 271: JOBS_MUST_BE_COMPLETED
        case 271:
          this.allJobsMustBeCompleted();
          return;

        // 272: PASSWORD_NOT_SUITABLE
        case 272:
          this.passwordNotSuitable();
          return;

        // 273: INVALID_TEMPLATE
        case 273:
          this.invalidTemplate();
          return;

        // 274: SFTP_NOT_ALLOWED
        case 274:
          this.sftpNotAllowed();
          return;

        // 275: BULK_SIGNING_NOT_ALLOWED
        case 275:
          this.bulkSigningNotAllowed();
          return;

        // 276: API_VERSION_INCOMPATIBLE
        case 276:
          this.apiVersionIncompatible();
          return;

        // 277: PADES_CADES_MIX_NOT_ALLOWED
        case 277:
          this.padesCadesMixNotAllowed();
          return;

        // 278: OLD_NEW_PADES_MIX_NOT_ALLOWED
        case 278:
          this.oldNewPadesMixNotAllowed();
          return;

        // 315: OLD_NEW_VERSION_MIX_NOT_ALLOWED
        case 315:
          this.oldNewVersionMixNotAllowed();
          return;

        // 279: OLD_PADES_NOT_SUPPORTED
        case 279:
          this.oldPadesNotSupported();
          return;

        // 280: ATTACHMENT_LIMIT_EXCEEDED
        case 280:
          this.attachmentLimitExceeded();
          return;

        // 281: ATTACHMENT_NOT_FOUND
        case 281:
          this.attachmentNotFound();
          return;

        // 282: ATTACHMENT_ALREADY_EXISTS
        case 282:
          this.attachmentAlreadyExists();
          return;

        // 283: ATTACHMENT_OPERATION_FAILED
        case 283:
          this.attachmentOperationFailed();
          return;

        // 284: NO_ATTACHMENTS
        case 284:
          this.noAttachments();
          return;

        // 285: ATTACHMENT_MODIFICATION_NOT_ALLOWED
        case 285:
          this.attachmentModificationNotAllowed();
          return;

        // 286: TOTAL_PDF_SIZE_EXCEEDED
        case 286:
          this.totalPdfSizeExceeded();
          return;

        // 287: SIGNATURE_FIELD_ALREADY_EXISTS
        case 287:
          this.signatureFieldAlreadyExists();
          return;

        // 288: INVALID_DOCUMENT
        case 288:
          this.invalidDocument();
          return;

        // 289: USER_EMAIL_NOT_VERIFIED
        case 289:
          this.showEmailNotVerifiedInfo(function() {});
          return;

        // 290: SIGNING_FAILED
        case 290:
          this.signingFailed();
          return;

        // 291: SIGNATURE_NAME_NOT_MATCH
        case 291:
          this.NameNotMatchError();
          return;

        // 292: SIGNATURE_CITIZENID_NOT_MATCH
        case 292:
          this.citizenIdNotMatch();
          return;

        // 293: DOCUMENT_ALREADY_REJECTED
        case 293:
          this.documentAlreadyRejected("others");
          return;

        // 294: ALREADY_DELETED
        case 294:
          this.alreadyDeleted();
          return;

        // 295: SIGNATURE_INTEGRITY_CHECK_FAILED
        case 295:
          this.signatureIntegrityCheckFailed();
          return;

        // 296: SIGNATURE_NOT_TRUSTED
        case 296:
          this.signatureNotTrusted();
          return;

        // 297: SIGNATURE_NOT_VALID_ON_SIGNING_DATE
        case 297:
          this.signatureNotValidOnSigningDate();
          return;

        // 298: NO_COUPON
        case 298:
          this.noCouponFound();
          return;

        // 309: ACCOUNT_DEACTIVATED
        case 309:
          this.accountDeactivated();
          return;

        // 310: SUBSCRIPTION_NOT_OWNED
        case 310:
          this.subscriptionNotOwned();
          return;

        // 311: NOTHING_TO_CANCEL
        case 311:
          this.nothingToCancel();
          return;

        // 312: SUBSCRIPTION_ALREADY_ENDED
        case 312:
          this.subscriptionAlreadyEnded();
          return;

        // 313: DELETE_NOT_AVAILABLE
        case 313:
          this.deleteAccountNotAvailable();
          return;

        // 314: INVALID_DELETION_CODE
        case 314:
          this.invalidDeletionCode();
          return;
      }
    }

    console.error("Error: " + error.status + " - " + errMsg);
    let serverError = "";

    if(error.status == 0){
      errMsg = "The server is not reachable.";
      this.serverNotReachable();
    }
    else if(error.status == 500){
      errMsg = this.translate.instant("An unexpected error has occurred, please notify our support team");
      serverError = '<a href="#">' + errMsg + '</a>';
      this.errorOccuredInServer();
    }

    if (errMsg == "Invalid Credentials")
      setTimeout(() => { this.router.navigate(['/']); }, 0);

    let  errorMessage = serverError || this.translate.instant(errMsg);
    let  headerMessage = this.translate.instant("Error!");

    if(errMsg == "Name in signature not match recipient name"){
      this.NameNotMatchError();
      return;
    }

    if(errMsg == "driver_error"){
      this.driverError();
      return;
    }

    this.sendMessageToParent("alert-danger", errorMessage);
    $.jGrowl(errorMessage, {
      position: 'top-right',
      theme: 'alert-bordered alert-styled-left alert-danger',
      animateClose: 'fadeOut',
      header: headerMessage,
      html:true
    });
  }

  private SwalAlert(title:string, text:string, options:any, callback:Function){
    let titleStr = title == "" ? "" : this.translate.instant(title);
    let textStr = text == "" ? "" :this.translate.instant(text);

    this.sendMessageToParent("alert-"+ options.type, titleStr + " " + textStr);

    // Map old type to new icon format
    const icon: SweetAlertIcon = options.type as SweetAlertIcon;

    const confirmText = this.translate.instant(options.confirmButtonText);
    const cancelText = this.translate.instant(options.cancelButtonText);

    // Pause PDF viewer before showing Swal to prevent change detection blocking
    this.pdfViewerControl.pausePdfViewer();

    // Wait 100ms for pause to take effect before showing Swal
    return new Promise<void>((resolve) => {
        const swalPromise = Swal.fire({
            title: titleStr,
            html: textStr, // Changed from text to html since old version used html: true
            icon: icon, // Changed from type to icon
            showCancelButton: options.showCancelButton,
            confirmButtonText: confirmText,
            cancelButtonText: cancelText,
            customClass: {
              confirmButton: options.confirmButtonClass,
              ...options.customClass
            }
          });

        swalPromise.then((result) => {
          if (callback) {
            callback(result.isConfirmed);
          }
          // Resume PDF viewer after Swal is dismissed
          this.pdfViewerControl.resumePdfViewer();
          resolve();
        });
    });
  }


  private gotoJob(jobID: number){
    //let message =  '<a (click)="gotoJob(jobId)">' + docName + '</a> is ...!';
    //let message =  `<a [routerLink]="['/doc/'` + jobId + `]">` + docName +`</a> is uploaded!`;
    this.router.navigate(['/doc', jobID]);
  }

  //!---MAIN FONCTIONS ---


  sendMessageToParent(status: string, message: string) {
    const payload = {
      status,
      message,
      timestamp: Date.now(),
    };

    // Always use parent.postMessage when in iframe
    if (window.parent !== window) {
      window.parent.postMessage(payload,"*"); // Set to exact allowed origin
      //TODO: add target origin !
    }
  }

  //--- JOB Notifications ---

  jobDeleted(jobName:string) {
    let message =  jobName + this.translate.instant(' is deleted!');
    let subtheme = 'alert-info';

    this.Notification(message, subtheme);
  }

  templateRenamed() {
    let message =  this.translate.instant('Template has been renamed.');
    let subtheme = 'alert-success';

    this.Notification(message, subtheme);
  }
  jobUploaded(docName:string) {
    let message = docName + this.translate.instant(' is uploaded!');
    let subtheme = 'alert-success';

    this.Notification(message, subtheme);
  }

  jobSigned(jobName:string) {
    let message = jobName + this.translate.instant(' is signed!');
    let subtheme = 'alert-success';

    this.Notification(message, subtheme);
  }

  jobRejected(jobName:string) {
    let message = jobName + this.translate.instant(' is rejected!');
    let subtheme = 'alert-info';

    this.Notification(message, subtheme);
  }

  featureNotPlanned() {
    let message = this.translate.instant('FEATURE_NOT_PLANNED');
    let subtheme = 'alert-info';

    this.Notification(message, subtheme);
  }

  signingError(jobName:string, reason: string) {
    let message =  "Signing error in document <b>'" + jobName + "'</b>" +  ": " + this.translate.instant(reason);
    if(this.translate.currentLang.toUpperCase() == "TR"){
      message = "<b>'" + jobName + "'</b> adlı belgede imzalama hatası: " + this.translate.instant(reason);
    }
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme, true);
  }

  OpenEIdSigningError(reason: string) {
    let message =  this.translate.instant(reason);
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme, true);
  }

  signatureAreaMissing(recipientNames: string[]) {
    let message = this.translate.instant("SIGNATURE_AREA_MISSING_FOR_RECIPIENTS", { recipients: (recipientNames || []).join(', ') });
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme, true);
  }

  /**
   * The bundle signer pressed Sign with the disclosure still outstanding.
   *
   * The server would reject this anyway (createMultiTokenSignature is gated), but a flat
   * rejection with nothing on screen explaining it is a dead end. This points them at the
   * banner that is already above the list.
   */
  disclosureNotAccepted() {
    let message = this.translate.instant("DISCLOSURE_NOT_ACCEPTED");
    let subtheme = 'alert-warning';

    this.Notification(message, subtheme, true);
  }

  jobCompleted(jobName:string) {
    let message = jobName + this.translate.instant(' is completed!');
    let subtheme = 'alert-success';

    this.Notification(message, subtheme);
  }

  jobMovedToInbox(jobName:string) {
    let message = jobName + this.translate.instant(' moved to Inbox!');
    let subtheme = 'alert-success';

    this.Notification(message, subtheme);
  }

  jobMovedToArchive(jobName:string) {
    let message = jobName + this.translate.instant(' moved to Archive!');
    let subtheme = 'alert-success';

    this.Notification(message, subtheme);
  }

  jobSaved(jobName:string) {
    let message = jobName + this.translate.instant(' is saved!');
    let subtheme = 'alert-info';

    this.Notification(message, subtheme);
  }

  jobCanceled(jobName:string) {
    let message = this.translate.instant('Signing of job is cancelled!');
    let subtheme = 'alert-info';

    this.Notification(message, subtheme);
  }

  signingTimeout(jobName:string) {
    let message = this.translate.instant('Signing of job is time out!');
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  signingApiCallError() {
    let message = this.translate.instant('Error occured in process. Please try again.');
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme, true);
  }

  signingMobileSignNotFound() {
    let message = this.translate.instant('No mobile-signature subscription found for the operator/number.');
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme, true);
  }

  signatureImageIsNotAppropriate() {
    let message = this.translate.instant('Error occurred in process. Please check file type, size, width and height properties.');
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme, true);
  }

  sharedSigningOptionsSaved() {
    let message = this.translate.instant('Shared signing options saved.');
    let subtheme = 'alert-success';

    this.Notification(message, subtheme, false);
  }

  sharedSigningOptionError(errorType:string) {
    let message;
    if(errorType == "NOTIFICATION_ERROR"){
      let message = this.translate.instant('Error occured while saving notification settings.');
    }else if(errorType == "SHARE_ERROR"){
      let message = this.translate.instant('Error occured while saving share settings.');
    }
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme, false);
  }

  searchFilterNotSuitable(){
    let message = this.translate.instant('At least 2 characters needed for search filter.');
    let subtheme = 'alert-info';

    this.Notification(message, subtheme, false);
  }

  //--- ACCOUNT Notifications ---

  revokeToken(callback:Function){
    let title = "Revoking token"
    let text = "After a token is revoked, you will not be able to use it anymore and need to generate a new token. Do you want to continue?";

    const options = {
      ...this.swalOptions,
      showCancelButton: true,
      confirmButtonText: "Yes",
      type: "info"
    };

    this.SwalAlert(title, text, options, function(isConfirmed:boolean) { callback(isConfirmed) })
  }

  afterRevokeToken(){
    let message = this.translate.instant("Token revoked successfully.");
    let subtheme = "alert-success";

    this.Notification(message,subtheme);
  }

  afterDeleteExpiredApiKey(){
    let message = this.translate.instant("Expired token deleted successfully.");
    let subtheme = "alert-success";

    this.Notification(message,subtheme);
  }

  resetCodeUsedOrNotValid(){
    let message =  this.translate.instant('Reset code is invalid or already used.');
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  accountInfoModified() {
    let message =  this.translate.instant('Your account info is modified!');
    let subtheme = 'alert-success';

    this.Notification(message, subtheme);
  }

  passwordChangeSent(email:string) { //to ' + email + '
    let message = this.translate.instant('Password Change Email has been sent your email address. Please check your inbox and use the link to reset your password');
    let subtheme = 'alert-info';
    let sticky:boolean = true;

    this.Notification(message, subtheme, sticky);
  }

  passwordChangedSuccessfully(callback:Function){
    let message =  this.translate.instant('Your password has been updated successfully. Please login again with your new password.');
    let title = this.translate.instant("Operation Successfull!");

    const options = {
      ...this.swalOptions,
      showCancelButton: false,
      confirmButtonText: "Login",
      type: "success"
    };

    this.SwalAlert(title, message, options, function(isConfirmed:boolean) { callback(isConfirmed) })
  }

  newAccountEmailApprovalRequestSent(email:string) {
    let message = this.translate.currentLang.toUpperCase() == "TR" ? "Hesabınıza ilişkin yeni e-posta ekleme isteği <b>" + email + "</b> e-posta adresine gönderildi" : 'Request to add new email address to your account has been sent to email address' + ": <b>" + email + "</b>";
    let subtheme = 'alert-info';
    let sticky:boolean = true;

    this.Notification(message, subtheme, sticky);
  }

  accountEmailDeleted(email:string) {

    let message = this.translate.currentLang.toUpperCase() == "TR" ? "<b>" + email + "</b> E-posta adresinin hesabınızla olan ilişkisi kaldırıldı" : "The association of the email address <b>" + email + "</b> with your account has been removed";
    let subtheme = 'alert-info';

    this.Notification(message, subtheme);
  }

  SuspendedSubscription() {
    let message =  this.translate.instant('Your subscription is suspended!');
    let subtheme = 'alert-warning';

    this.Notification(message, subtheme);
  }

  /**
   * @param deactivatedAt already formatted, or empty when the server did not say when. The dated
   *        wording is worth the branch: "deactivated" alone leaves someone with nothing to check.
   */
  accountDeactivated(deactivatedAt?:string) {
    let message = deactivatedAt
      ? this.translate.instant('ACCOUNT_DEACTIVATED_ON', {date: deactivatedAt})
      : this.translate.instant('ACCOUNT_DEACTIVATED');
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  subscriptionNotOwned() {
    let message = this.translate.instant('SUBSCRIPTION_NOT_OWNED');
    let subtheme = 'alert-warning';

    this.Notification(message, subtheme);
  }

  nothingToCancel() {
    let message = this.translate.instant('NOTHING_TO_CANCEL');
    let subtheme = 'alert-warning';

    this.Notification(message, subtheme);
  }

  subscriptionAlreadyEnded() {
    let message = this.translate.instant('SUBSCRIPTION_ALREADY_ENDED');
    let subtheme = 'alert-warning';

    this.Notification(message, subtheme);
  }

  deleteAccountNotAvailable() {
    let message = this.translate.instant('DELETE_ACCOUNT_GATE_CLOSED');
    let subtheme = 'alert-warning';

    this.Notification(message, subtheme);
  }

  invalidDeletionCode() {
    let message = this.translate.instant('DELETE_CONFIRM_LINK_INVALID');
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  subscriptionCancelled(effectiveEndDate:string) {
    let message = this.translate.instant('SUBSCRIPTION_CANCELLED_TOAST', {date: effectiveEndDate});
    let subtheme = 'alert-success';

    this.Notification(message, subtheme);
  }

  subscriptionResumed() {
    let message = this.translate.instant('SUBSCRIPTION_RESUMED_TOAST');
    let subtheme = 'alert-success';

    this.Notification(message, subtheme);
  }

  deleteAccountLinkSent(email:string) {
    let message = this.translate.instant('DELETE_ACCOUNT_LINK_SENT', {email: email});
    let subtheme = 'alert-info';

    this.Notification(message, subtheme);
  }

  deletionRequestAborted() {
    let message = this.translate.instant('DELETION_ABORTED_TOAST');
    let subtheme = 'alert-success';

    this.Notification(message, subtheme);
  }

  showCancelSubscriptionAlert(planName:string, effectiveEndDate:string, callback:Function) {
    let title = this.translate.instant('CANCEL_SUBSCRIPTION_CONFIRM_TITLE', {plan: planName});
    let text = this.translate.instant('CANCEL_SUBSCRIPTION_CONFIRM_TEXT', {date: effectiveEndDate});

    const options = {
      ...this.swalOptions,
      confirmButtonText: "Cancel subscription",
      cancelButtonText: "Keep my subscription",
      showCancelButton: true,
      type: "warning"
    };

    this.SwalAlert(title, text, options, function(isConfirmed:boolean) { callback(isConfirmed) })
  }

  showResumeSubscriptionAlert(callback:Function) {
    const options = {
      ...this.swalOptions,
      confirmButtonText: "Resume subscription",
      showCancelButton: true,
      type: "question"
    };

    this.SwalAlert('RESUME_SUBSCRIPTION_CONFIRM_TITLE', 'RESUME_SUBSCRIPTION_CONFIRM_TEXT', options, function(isConfirmed:boolean) { callback(isConfirmed) })
  }

  showAbortDeletionAlert(callback:Function) {
    const options = {
      ...this.swalOptions,
      confirmButtonText: "Cancel deletion request",
      showCancelButton: true,
      type: "question"
    };

    this.SwalAlert('ABORT_DELETION_CONFIRM_TITLE', 'ABORT_DELETION_CONFIRM_TEXT', options, function(isConfirmed:boolean) { callback(isConfirmed) })
  }

  /**
   * Strong confirmation for account deletion: the user types the confirmation word and ticks an
   * acknowledgement. Goes straight to Swal rather than through SwalAlert, which has no input support.
   * The typed word is the same literal in every language so one validator covers all of them.
   */
  showDeleteAccountConfirm(callback:Function) {
    const confirmWord = 'DELETE';
    const title = this.translate.instant('DELETE_ACCOUNT_CONFIRM_TITLE');
    const explain = this.translate.instant('DELETE_ACCOUNT_EXPLAIN');
    const typePrompt = this.translate.instant('DELETE_ACCOUNT_CONFIRM_TYPE', {word: confirmWord});
    const ack = this.translate.instant('DELETE_ACCOUNT_CONFIRM_ACK');
    const typeError = this.translate.instant('DELETE_ACCOUNT_CONFIRM_TYPE_ERROR', {word: confirmWord});
    const ackError = this.translate.instant('DELETE_ACCOUNT_CONFIRM_ACK_ERROR');

    this.sendMessageToParent("alert-warning", title + " " + explain);
    this.pdfViewerControl.pausePdfViewer();

    Swal.fire({
      title: title,
      icon: 'warning',
      html: '<p>' + explain + '</p><p>' + typePrompt + '</p>'
        + '<label class="swal-delete-ack"><input type="checkbox" id="deleteAccountAck"> <span>' + ack + '</span></label>',
      input: 'text',
      inputPlaceholder: confirmWord,
      inputAttributes: { autocapitalize: 'off', autocorrect: 'off' },
      showCancelButton: true,
      confirmButtonText: this.translate.instant('Delete account'),
      cancelButtonText: this.translate.instant(this.swalOptions.cancelButtonText),
      customClass: {
        confirmButton: 'btn-danger',
        ...this.swalOptions.customClass
      },
      preConfirm: (typed:string) => {
        const acknowledged = (document.getElementById('deleteAccountAck') as HTMLInputElement)?.checked;
        if ((typed || '').trim() !== confirmWord) {
          Swal.showValidationMessage(typeError);
          return false;
        }
        if (!acknowledged) {
          Swal.showValidationMessage(ackError);
          return false;
        }
        return true;
      }
    }).then((result) => {
      this.pdfViewerControl.resumePdfViewer();
      callback(result.isConfirmed === true && result.value === true);
    });
  }

  sftpServerAdded(){
    let message =  this.translate.instant('SFTP server added successfully.');
    let subtheme = 'alert-success';

    this.Notification(message, subtheme);
  }

  sftpServerAddedError(){
    let message =  this.translate.instant('An error occured while adding SFTP server.');
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  sftpServerDeleted(){
    let message =  this.translate.instant('SFTP server deleted successfully.');
    let subtheme = 'alert-success';

    this.Notification(message, subtheme);
  }

  sftpServerDeletedError(){
    let message =  this.translate.instant('An error occured while deleting SFTP server.');
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  sftpServerUpdated(){
    let message =  this.translate.instant('SFTP server updated successfully.');
    let subtheme = 'alert-success';

    this.Notification(message, subtheme);
  }

  sftpServerUpdatedError(){
    let message =  this.translate.instant('An error occured while updating SFTP server.');
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  sftpFileSentSuccess(){
    let message =  this.translate.instant('Your document has been scheduled to be sent to the specified destination. The result of the transaction will be notified to you by e-mail.');
    let subtheme = 'alert-success';

    this.Notification(message, subtheme);
  }

  sftpFileSentError(){
    let message =  this.translate.instant('An error occured while sending document to selected SFTP server.');
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  showAccountSftpDeleteAlert(sftp:string, callback:Function) {
    let title = this.translate.currentLang.toUpperCase() == "TR" ? "<b>" + sftp + "</b> SFTP sunucusunu silmek istediğinizden emin misiniz?" : "Do you really want to remove the <b>" + sftp + "</b> SFTP server?";
    let text = "You won't be able to revert this!";

    const options = {
      ...this.swalOptions,
      confirmButtonText: "Yes",
      showCancelButton: true
    };

    this.SwalAlert(title, text, options, function(isConfirmed:boolean) { callback(isConfirmed) })
  }

  showInvalidCredentialsAlert(){
    let message =  this.translate.instant('API Key is invalid.');
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  showInvalidCredentialsForLoginAlert(){
    let message =  this.translate.instant('Email and password does not match.');
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  showUserAlreadyExistsForRegisterAlert(){
    let message =  this.translate.instant('This email is in use.');
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  showRedirectToLoginPage(callback:any){
    let message =  this.translate.instant('Document uploaded successfully, but you used API Key to upload document so you will be redirected to login screen. If your browser don\'t redirect you, please click on \'Login\' button below.');
    let title = this.translate.instant("Login required");

    const options = {
      ...this.swalOptions,
      showCancelButton: true,
      confirmButtonText: "Login",
      type: "success"
    };

    this.SwalAlert(title, message, options, function(isConfirmed:boolean) { callback(isConfirmed) })
  }

  //--- TEAM MANAGEMENT Notifications ---

  showRemoveTeamMemberAlert(memberEmail:string, callback:Function) {
    let title = this.translate.currentLang.toUpperCase() == "TR" ? "<b>" + memberEmail + "</b> e-posta adresine sahip olan kişiyi takımdan çıkartmak istediğinize emin misiniz?" : "Do you really want to remove the person from your team with the <b>" + memberEmail + "</b> email address?";
    let text = "You won't be able to revert this!";

    const options = {
      ...this.swalOptions,
      confirmButtonText: "Yes"
    };

    this.SwalAlert(title, text, options, function(isConfirmed:boolean) { callback(isConfirmed) })
  }

  showCancelTeamMemberRequestAlert(memberEmail:string, callback:Function){
    let title = this.translate.currentLang.toUpperCase() == "TR" ? "<b>" + memberEmail + "</b> e-posta adresine sahip olan kişiye yolladığınız isteği iptal etmek istediğinize emin misiniz?" : "Are you sure you want to cancel the request you sent to the person who has the <b>" + memberEmail + "</b> e-mail address?";
    let text = "You won't be able to revert this!";

    const options = {
      ...this.swalOptions,
      confirmButtonText: "Yes"
    };

    this.SwalAlert(title, text, options, function(isConfirmed:boolean) { callback(isConfirmed) })
  }

  showTransferFilesAlert(callback:Function){
    let title = this.translate.instant("File Transfer");
    let message =  this.translate.instant("All the files you have before joining the organization will be transferred to the team owner. This action is irreversible!<br>Do you confirm?");

    const options = {
      ...this.swalOptions,
      confirmButtonText: "Yes",
      showCancelButton: true
    };

    this.SwalAlert(title, message, options, function(isConfirmed:boolean) { callback(isConfirmed) })
  }

  showNoUserFoundAlert(){
    let message = this.translate.instant('No user found with the provided email.');
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  showUserAlreadyInTeam(){
    let message = this.translate.instant('User is already in a team.');
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  showTeamMemberRequestSent(){
    let message = this.translate.instant('Team request sent to user.');
    let subtheme = 'alert-success';

    this.Notification(message, subtheme);
  }

  showTeamMemberRemoved(){
    let message = this.translate.instant('User removed from team.');
    let subtheme = 'alert-info';

    this.Notification(message, subtheme);
  }

  showTeamMemberRequestCancelled(){
    let message = this.translate.instant('Team request cancelled.');
    let subtheme = 'alert-info';

    this.Notification(message, subtheme);
  }

  departmentUpdated(){
    let message = this.translate.instant('Department changed successfully');
    let subtheme = 'alert-success';

    this.Notification(message,subtheme);
  }

  transferFileCompleted(){
    let message = this.translate.instant('Document transfer completed.');
    let subtheme = 'alert-success';

    this.Notification(message,subtheme);
  }

  teamMemberQuotaFull(){
    let message = this.translate.instant("Team member quota is full.");
    let subtheme = "alert-danger"

    this.Notification(message,subtheme);
  }

  //--- SIGNING Notifications ---

  certificateExpiringSoon(){
    let message = this.translate.instant("Your certificate expires in less than 20 days. Signing cannot be made at the closing of the document due to the risk of your certificate expired. Please renew your certificate.")
    let subtheme = "alert-danger";

    this.Notification(message,subtheme,true);
  }

  mandatoryFieldsNotFilled() {
    let message = this.translate.instant('Mandatory field(s) must be filled');
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  signingRequestSent() {
    let message = this.translate.instant('Signing request is sent to recipient email adresses');
    let subtheme = 'alert-info';

    this.Notification(message, subtheme);
  }

  signingRequestSaved(jobName:string) {
    let message = this.translate.instant('Signing request for job is saved!');
    let subtheme = 'alert-info';

    this.Notification(message, subtheme);
  }

  apiKeyCopied() {
    let message = this.translate.instant('API key was copied.');
    let subtheme = 'alert-success';

    this.Notification(message, subtheme);
  }

  callbackAddressSaved() {
    let message = this.translate.instant('Callback address was saved.');
    let subtheme = 'alert-success';

    this.Notification(message, subtheme);
  }

  documentShared() {
    let message = this.translate.instant('Document shared');
    let subtheme = 'alert-success';

    this.Notification(message, subtheme);
  }


  NameNotMatchError() {
    let errMsg = "The requested signer name and the actual signer name are different. If you created the request, please check the link below.";
    let errorMessage = this.translate.instant(errMsg);
    errorMessage = errorMessage+"<br><a target='_blank' href='https://hub.ilerian.com/sss#imzalayan-isminin-uyusmamasi'>" + this.translate.instant("Signer Name Mismatch") + "</a>";

    let subtheme = 'alert-danger';
    this.Notification(errorMessage, subtheme, true);
  }

  driverError(){
    let errMsg = "Driver Error<ul><li>Is the token driver installed?</li><li>Is the card reader driver installed?</li><li>Has the token been plugged?</li></ul>Please contact with the support if the problem still occurs.";
    let errorMessage = this.translate.instant(errMsg);
    errorMessage = errorMessage + "<br><a target='_blank' href='https://hub.ilerian.com/tr-tr/imza-yeri-eimza-kurulum'>"+ this.translate.instant("View installation instructions") +"</a>";

    let subtheme = 'alert-danger';
    this.Notification(errorMessage, subtheme, true);
  }

  bulkSignError(){
    let errMsg = "Signing failed because some of the documents are on <b>REJECTED</b> or <b>COMPLETED</b> state.";
    let errorMessage = this.translate.instant(errMsg);

    let subtheme = 'alert-danger';
    this.Notification(errorMessage, subtheme, false);
  }

  multiSignNotExpected(){
    let errMsg = "No signing request exists for this code. Signer might sign or reject the document";
    let errorMessage = this.translate.instant(errMsg);

    let subtheme = 'alert-danger';
    this.Notification(errorMessage, subtheme, false);
  }

  userNotSignedIn(callback:Function){
    let title = this.translate.instant("User not logged in.");
    let message = this.translate.instant('To upload your document, you need to be signed in. Please sign in and try again.');

    const options = {
      ...this.swalOptions,
      showCancelButton: true,
      confirmButtonText: "Login",
      type: "warning"
    };

    this.SwalAlert(title, message, options, function(isConfirmed:boolean) { callback(isConfirmed) })
  }

  //--- DOCUMENT Notifications ---

  fileNameTooLong(){
    let message = this.translate.instant("File name is too long.");
    let subtheme = 'alert-danger';

    this.Notification(message,subtheme);
  }

  googleDriveFileGetError() {
    let message = this.translate.instant("You do not have access to the file or the file does not exist");
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  documentDownloadStarted(docName:string) {
    let message = docName + ' ' + this.translate.instant('download started!');
    let subtheme = 'alert-success';

    this.Notification(message, subtheme);
  }

  documentNotFound() {
    let message = this.translate.instant('The document can not be accessed. It may be corrupted or deleted!');
    let subtheme = 'alert-danger';
    let sticky:boolean = true;

    this.Notification(message, subtheme, sticky);
  }

  largeFileToUpload() {
    let message = this.translate.instant('File is too large to upload! Max file size is 10 MB');
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  fileTypeNotMatchToUpload() {
    let message = this.translate.instant('File type is incompatible to upload. File type must be in .jpg, .jpeg, .gif, .png, or .pdf');
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  documentsCombined() {
    let message = this.translate.instant('Documents were successfully combined');
    let subtheme = 'alert-success';

    this.Notification(message, subtheme);
  }

  recipientUsedMoreThanOne(){
    let message = this.translate.instant('The same recipient was used multiple times');
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  oneOfRecipientsShouldIncludeUserEmail(){
    let message = this.translate.instant("One of the recipients must be edited with the user's email address");
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  uploadedFilesShoudBeMoreThanOne() {
    let message = this.translate.instant('The number of uploaded files must be more than one');
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  publicLinkCopied() {
    let message = this.translate.instant('The public link was copied');
    let subtheme = 'alert-success';

    this.Notification(message, subtheme);
  }

  signingLinkCopied() {
    let message = this.translate.instant('Signing link copied to clipboard');
    let subtheme = 'alert-success';

    this.Notification(message, subtheme);
  }

  showSigningLinkWarning(recipientName: string, callback: Function) {
    let title = this.translate.instant("Security Warning");
    let text = this.translate.instant("SIGNING_LINK_WARNING", { name: recipientName });

    const options = {
      ...this.swalOptions,
      confirmButtonText: this.translate.instant("Yes, get the link"),
      showCancelButton: true,
      type: "warning"
    };

    this.SwalAlert(title, text, options, (isConfirmed: boolean) => { callback(isConfirmed); });
  }

  errorDurindCSFFileDownload() {
    let message = this.translate.instant('Error occured in process. Please try again.');
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  publicLinSharingStopped() {
    let message = this.translate.instant('The public link sharing stopped');
    let subtheme = 'alert-info';

    this.Notification(message, subtheme);
  }

  templateCreated() {
    let message = this.translate.instant('Template created');
    let subtheme = 'alert-success';

    this.Notification(message, subtheme);
  }

  bulkOperationCompleted(operation:string) {
    let action:string = "";
    if(operation == "Delete") action = "deleted";
    if(operation == "Move to Inbox") action = "moved to Inbox";
    if(operation == "Archive") action = "archived";
    if(operation == "Download") action = "downloaded";
    if(operation == "ApplyTemplateAndSend") action = "prepared for signing request";

    let message =  this.translate.instant("Selected documents has been " + action);
    let subtheme = 'alert-info';

    if( action != ""){
      this.Notification(message, subtheme);
    }
  }

  googleDocsCorsError(){
    let message = this.translate.instant('Document could not downloaded due to permissions. Please change the visibility options of your Google Docs document.');
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme, true);
  }

  fromDriveMissingParameters(){
    let message = this.translate.instant('The link is broken, are you sure you used our Google Docs add-on?');
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme, true);
  }

  allJobsMustBeCompleted(){
    let message = this.translate.instant('All documents must be completed to download in bulk.');
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme, true);
  }

  //--- RECIPIENTS---

  recipientAdded(recipientName:string) {
    let message = this.translate.instant('Recipient') + ' '+ recipientName + ' '+ this.translate.instant('was added to Recipient List!');
    let subtheme = 'alert-success';

    this.Notification(message, subtheme);
  }

  noRecipientExist() {
    let message = this.translate.instant('No recipients is exist! Please recipient add first');
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  recipientDeleted(recipientName:string) {
    let message = this.translate.instant('Recipient') + ' '+ recipientName + ' '+ this.translate.instant('was deleted from Recipient List!');
    let subtheme = 'alert-info';

    this.Notification(message, subtheme);
  }

  documentAlreadyRejected(byWhom:string) {
    let message = byWhom == "you" ? this.translate.instant("Document was already rejected by you") : this.translate.instant("Document was already rejected by others")
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme, true);
  }

  addressBookIsEmpty(){
    let message = this.translate.instant('Your address book is empty.');
    let subtheme = 'alert-info';

    this.Notification(message, subtheme, false);
  }

  recipientUpdated(){
    let message = this.translate.instant("Recipient info updated.");
    let subtheme = "alert-info";

    this.Notification(message,subtheme,false);
  }

  smsQuotaIsFull(){
    let message = this.translate.instant("SMS Verification quota is full.");
    let subtheme = "alert-danger"

    this.Notification(message,subtheme,false);
  }

  //--- UPGRADE PLAN---

  selectedPlanNotSuitToUpgrade() {
    let message = this.translate.instant('Selected plan is not suit to upgrade. Please select another plan to upgrade!');
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  validationStampOptionUpdated() {
    let message = this.translate.instant('Validation stamp updated');
    let subtheme = 'alert-success';

    this.Notification(message, subtheme);
  }

  notificationPreferencesSaved() {
    let message = this.translate.instant('Notification settings saved successfully.');
    let subtheme = 'alert-success';

    this.Notification(message, subtheme);
  }

  notificationPreferencesSaveError() {
    let message = this.translate.instant('Error occured while saving notification settings.');
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  signingRequestResentToRecipient() {
    let message = this.translate.instant('Signing request resent to recipient');
    let subtheme = 'alert-success';

    this.Notification(message, subtheme);
  }

  templateApplied() {
    let message = this.translate.instant('Template applied');
    let subtheme = 'alert-info';

    this.Notification(message, subtheme);
  }

  jobCreatedFromTemplate() {
    let message = this.translate.instant('New document created from template');
    let subtheme = 'alert-success';

    this.Notification(message, subtheme);
  }

  changeOneorMoreRecipientFirst() {
    let message = this.translate.instant('You must first change one or more recipient(s)');
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  publicLinkCreated(link:string) {
    let message = this.translate.instant('Public link created') + " <br> " +link;
    let subtheme = 'alert-success';
    let sticky:boolean = true;

    this.Notification(message, subtheme, sticky);
  }

  documentSingingRequestSent() {
    let message = this.translate.instant('Document signing request sent to recipients');
    let subtheme = 'alert-success';
    let sticky:boolean = true;

    this.Notification(message, subtheme, sticky);
  }

  noApiUsageRights() {
    let message = this.translate.instant('You do not have the right to use the API, please contact us at the support section.');
    let subtheme = 'alert-danger';
    let sticky:boolean = true;

    this.Notification(message, subtheme, sticky);
  }

  //-----  ALERTS -----
  showDocumentSigningRequestSentToRecipient(callback:Function) {
    let title = 'The document has been sent to recipients. All recipients should sign the document with qualified electronic signature provided by a certified signature dealer.';
    let text = "";

    const options = {
      ...this.swalOptions,
      showCancelButton: false,
      type: "success"
    };

    this.SwalAlert(title, text, options, function(isConfirmed:boolean) { callback(isConfirmed) })
  }

  showRecipientInfoChangedAlert(callback:Function) {
    let title = 'All signers will be informed about the change. Do you confirm?';
    let text = "";

    const options = {
      ...this.swalOptions,
      confirmButtonText: "Yes"
    };

    this.SwalAlert(title, text, options, function(isConfirmed:boolean) { callback(isConfirmed) })
  }

  showJobDeleteAlert(removeItem:string, callback:Function) {
    let title = 'Do you really want to delete the ' +  removeItem + '?';
    let text = "You won't be able to revert this!";

    const options = {
      ...this.swalOptions,
      confirmButtonText: "Yes",
      showCancelButton: true,
      type: "warning"
    };

    this.SwalAlert(title, text, options, function(isConfirmed:boolean) { callback(isConfirmed) })
  }

  showAllJobsSigned(unsignedJobs:string[], callback:Function) {
    let title = '';
    let text = "All documents have been successfully signed.";
    if(unsignedJobs.length > 0) {
      text = this.translate.currentLang.toUpperCase() == "TR" ? "<h5>Aşağıdaki belgeler hariç tüm belgeler imzalandı:</h5>" : "<h5>All documents, except the following documents were signed:</h5>";
      unsignedJobs.forEach(function(unsigned) {
        text+= "<br>" + unsigned;
      });

    }

    const options = {
      ...this.swalOptions,
      confirmButtonText: "OK",
      type: "success",
      showCancelButton: false
    };

    this.SwalAlert(title, text, options, function(isConfirmed:boolean) { callback(isConfirmed) })
  }

  showURLInfoIncorrent(callback:Function) {
    let title = "URL maybe incorrect.";
    let text = "";

    const options = {
      ...this.swalOptions,
      confirmButtonText: "OK",
      type: "warning",
      showCancelButton: false
    };

    this.SwalAlert(title, text, options, function(isConfirmed:boolean) { callback(isConfirmed) })
  }

  showJobSigningCancelAlert(callback:Function) {
    let title = 'Do you really want to cancel signing process?';
    let text = "";

    const options = {
      ...this.swalOptions,
      confirmButtonText: "Yes"
    };

    this.SwalAlert(title, text, options, function(isConfirmed:boolean) { callback(isConfirmed) })
  }

  showJobSigningRejectAlert(callback:Function) {
    let title = 'Do you really want to reject signing?';
    let text = "You won't be able to revert this!";

    const options = {
      ...this.swalOptions,
      confirmButtonText: "Yes"
    };

    this.SwalAlert(title, text, options, function(isConfirmed:boolean) { callback(isConfirmed) })
  }

  showRecipientDeleteAlert(callback:Function) {
    let title = 'Do you really want to delete the recipient?';
    let text = "You won't be able to revert this!";

    const options = {
      ...this.swalOptions,
      confirmButtonText: "Yes"
    };

    this.SwalAlert(title, text, options, function(isConfirmed:boolean) { callback(isConfirmed) })
  }

  showAccountEmailDeleteAlert(email:string, callback:Function) {
    let title = this.translate.currentLang.toUpperCase() == "TR" ? "<b>" + email + "</b> e-posta adresinin hesabınızla ilişkisinin kaldırılmasını gerçekten istiyor musunuz?" : "Do you really want to remove the association of <b>" + email + "</b> with your account";
    let text = "You won't be able to revert this!";

    const options = {
      ...this.swalOptions,
      confirmButtonText: "Yes"
    };

    this.SwalAlert(title, text, options, function(isConfirmed:boolean) { callback(isConfirmed) })
  }

  showRecipientOrderContainerDeleteAlert(containerNo:number, callback:Function) {
    let title = this.translate.instant("There is an empty row in the signing request") + " (" + containerNo +"), " +  this.translate.instant("do you want to delete it?");
    let text = "You won't be able to revert this!";

    const options = {
      ...this.swalOptions,
      confirmButtonText: "Yes"
    };

    this.SwalAlert(title, text, options, function(isConfirmed:boolean) { callback(isConfirmed) })
  }

  showBulkOperationAlert(operation:string, callback:Function) {
    let title = operation == "Delete" ? "Do you really want to delete selection documents?" : '';
    let text = "Do you really want to move to inbox selection documents?";

    if(operation == "Archive")
      text = "Do you really want to archive selection documents?";
    else if(operation == "Delete") {
      text = "You won't be able to revert this!";
    }
    else if(operation == "BulkSign") {
      text = "Do you want to sign selected documents?";
    }

    const options = {
      ...this.swalOptions,
      confirmButtonText: "Yes",
      showCancelButton: true,
      type: "warning"
    };

    this.SwalAlert(title, text, options, function(isConfirmed:boolean) { callback(isConfirmed) })
  }

  showPaymentErrorAlert(errorMessage:string, callback:Function) {
    let title = 'Error in process!';
    let text = errorMessage;

    const options = {
      ...this.swalOptions,
      showCancelButton: false,
      type: "error"
    };

    this.SwalAlert(title, text, options, function(isConfirmed:boolean) { callback(isConfirmed) });
  }

  showPleaseFillTheForm(){
    let message = this.translate.instant('Please fill the required fields.');
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  showTokenExpiredAlert(callback:Function) {
    let title = 'Error in process!';
    let text = 'Your session is timeout. Please login again.';

    const options = {
      ...this.swalOptions,
      showCancelButton: false,
      type: "error"
    };

    this.SwalAlert(title, text, options, function(isConfirmed:boolean) { callback(isConfirmed) });
  }

  showAnErrorOccuredInServer(callback:Function) {
    let title = 'Error in process!';
    let text = 'Please try again later';

    const options = {
      ...this.swalOptions,
      showCancelButton: false,
      confirmButtonText: "Refresh Page",
      type: "error"
    };

    this.SwalAlert(title, text, options, function(isConfirmed:boolean) { callback(isConfirmed) });
  }

  showServerNotReachable(callback:Function) {
    let title = 'Error in process!';
    let text = 'Please try again later';

    const options = {
      ...this.swalOptions,
      showCancelButton: false,
      type: "error",
      confirmButtonText: "Ok"
    };

    this.SwalAlert(title, text, options, function(isConfirmed:boolean) { callback(isConfirmed) });
  }

  showJobRejected(isRegistered:string, callback:Function) {
    let title = ''; //Signing status
    this.translate.get("REJECTED_SIGNING",{title:Config.TITLE}).subscribe((res:string)=>{
      let text = res;
      text += isRegistered == "false" ? this.translate.instant("<br>Registration is free and we have free plan after trial period.") : "";

      const options = {
        ...this.swalOptions,
        showCancelButton: false,
        confirmButtonText: "OK",
        type: "info"
      };

      this.SwalAlert(title, text, options, function(isConfirmed:boolean) { callback(isConfirmed) });
    })
  }

  showJobSigned(isRegistered:string, callback:Function) {
    let title = ''; //Signing status

    // let text = this.translate.instant('SIGNED_SUCCESSFULLY', [Config.TITLE]);
    this.translate.get("SIGNED_SUCCESSFULLY",{title:Config.TITLE}).subscribe((res:string)=>{
      let text = res;
      text += isRegistered == "false" ? this.translate.instant("<br>Registration is free and we have free plan after trial period.") : "";

      const options = {
        ...this.swalOptions,
        showCancelButton: false,
        confirmButtonText: "OK",
        type: "success"
      };

      this.SwalAlert(title, text, options, function(isConfirmed:boolean) { callback(isConfirmed) });
    })

  }

  showRequestCodeAlreadyUsed(errMessage:string, callback:Function) {
    let title = ''; //Signing status
    let text = errMessage;

    const options = {
      ...this.swalOptions,
      showCancelButton: false,
      confirmButtonText: "OK",
      type: "error"
    };

    this.SwalAlert(title, text, options, function(isConfirmed:boolean) { callback(isConfirmed) });
  }

  showAccountReachedMaxSignatureLimit(callback:Function) {
    let title = "";
    let text = "Your plan's monthly usage has expired";

    const options = {
      ...this.swalOptions,
      showCancelButton: false,
      confirmButtonText: "OK",
      type: "error"
    };

    this.SwalAlert(title, text, options, function(isConfirmed:boolean) { callback(isConfirmed) });
  }

  showSignFieldInfo(callback:Function) {
    let title = "";
    let text = "Signer Certificate Information shall be displayed here after signing workflow completed";

    const options = {
      ...this.swalOptions,
      showCancelButton: false,
      confirmButtonText: "OK",
      type: "info"
    };

    this.SwalAlert(title, text, options, function(isConfirmed:boolean) { callback(isConfirmed) });
  }

  showCurrentPlanNotSuitToDo(callback:Function) {
    let title = "";
    let text = "You have to upgrade your plan to use this feature";

    const options = {
      ...this.swalOptions,
      showCancelButton: false,
      confirmButtonText: "OK"
    };

    this.SwalAlert(title, text, options, function(isConfirmed:boolean) { callback(isConfirmed) });
  }

  showQuotaFull(used:number, available:number, callback:Function) {
    let title = "";
    let text = this.translate.currentLang.toUpperCase() == "TR" ? "Disk kotası dolu. Kullanılan alan " + used + " MB, tanımlı kota " + available + " MB" : "The quota was full, there's no free space left. Space used " + used + " MB, available quota " + available + " MB";

    const options = {
      ...this.swalOptions,
      showCancelButton: false,
      confirmButtonText: "OK"
    };

    this.SwalAlert(title, text, options, function(isConfirmed:boolean) { callback(isConfirmed) });
  }

  showTemplateError(callback:Function) {
    let title = "";
    let text = "The template cannot be applied to the document you selected because there are widgets on the extra pages of the template.";

    const options = {
      ...this.swalOptions,
      showCancelButton: false,
      confirmButtonText: "OK",
      type: "error"
    };

    this.SwalAlert(title, text, options, function(isConfirmed:boolean) { callback(isConfirmed) });
  }

  showTemplateErrorMultiple(callback:Function) {
    let title = "";
    let text = "The template cannot be applied because the page number of the template you want to apply does not match the page number of one or more documents and there are tools on the extra pages of the template.";

    const options = {
      ...this.swalOptions,
      showCancelButton: false,
      confirmButtonText: "OK",
      type: "error"
    };

    this.SwalAlert(title, text, options, function(isConfirmed:boolean) { callback(isConfirmed) });
  }

  showTemplateErrorMultipleJobNotNone(callback:Function) {
    let title = "";
    let text = "In order for the template to be applied, the process must not be started on any documents.";

    const options = {
      ...this.swalOptions,
      showCancelButton: false,
      confirmButtonText: "OK",
      type: "error"
    };

    this.SwalAlert(title, text, options, callback);
  }

  showTemplateVersionConflict(callback:Function) {
    let title = "";
    let text = "This template includes signature positions which belongs to the older coordinate system and it should be upgraded";

    const options = {
      ...this.swalOptions,
      showCancelButton: true,
      confirmButtonText: "Edit Template",
      cancelButtonText: "Cancel",
      type: "warning"
    };

    this.SwalAlert(title, text, options, function(isConfirmed:boolean) { callback(isConfirmed) });
  }

  showWantToSignBioSign(callback:Function) {
    let title = "";
    let text = "The document will be signed by basic (eIDAS) signing. Do you approve?";

    const options = {
      ...this.swalOptions,
      showCancelButton: true,
      confirmButtonText: "Yes",
      type: "info"
    };

    this.SwalAlert(title, text, options, function(isConfirmed:boolean) {
      callback(isConfirmed)
    });
  }

  showDigitalSignatureRequired(callback:Function) {

    let title = "Place for Digital Signature Information";
    let text = "Your name will be displayed here after signing the document.";

    const options = {
      ...this.swalOptions,
      showCancelButton: false,
      confirmButtonText: "OK",
      type: "info"
    };

    this.SwalAlert(title, text, options, function(isConfirmed:boolean) {
      callback(isConfirmed);
    });
  }

  showSmsTimedOutAlert(callback:Function){
    let title = "SMS verification time is up."
    let text = "You did not enter your SMS verification code within the expected time. Would you like us to resend the code?"

    const options = {
      ...this.swalOptions,
      showCancelButton: true,
      confirmButton: "Resend Password",
      type: "info"
    };

    this.SwalAlert(title, text, options, function(isConfirmed:boolean){ callback(isConfirmed) });
  }

  showSmsPasswordIncorrect(){
    let message = this.translate.instant('SMS Password inccorrect.');
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  showSmsPasswordExpired(){
    let message = this.translate.instant('SMS Password expired.');
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  showMandatoryFieldsNotFilled(callback:Function) {
    let title = "";
    let text = "Mandatory field(s) must be filled";

    const options = {
      ...this.swalOptions,
      showCancelButton: false,
      confirmButtonText: "OK",
      type: "error"
    };

    this.SwalAlert(title, text, options, function(isConfirmed:boolean) { callback(isConfirmed) });
  }

  showEmailNotVerifiedInfo(callback:Function) {
    let title = 'Account created';
    this.translate.get("ACCOUNT_CREATED",{title:Config.TITLE}).subscribe((res:string)=>{
      let text = res;

      const options = {
        ...this.swalOptions,
        showCancelButton: false,
        confirmButtonText: "I have verified email address",
        type: "success"
      };

      this.SwalAlert(title, text, options, function(isConfirmed:boolean) { callback(isConfirmed) });
    })
  }

  tryAgainLater(){
    let message = this.translate.instant('Unknown error occured, please try again.');
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme, true);
  }

  showStripePaymentError(errorMessage: string){
    let title = this.translate.instant('Payment Failed');
    let text = errorMessage;

    const options = {
      ...this.swalOptions,
      showCancelButton: false,
      type: "error"
    };

    this.SwalAlert(title, text, options, function(){});
  }

  showEmailCanNotBeUsed(callback:Function){
    let title = 'Session Expired';
    let text = "Your session has been expired. Please click the 'OK' button to log in again.";

    const options = {
      ...this.swalOptions,
      showCancelButton: false,
      confirmButtonText: "OK",
      type: "info"
    };

    this.SwalAlert(title, text, options, function(isConfirmed:boolean) { callback(isConfirmed) });
  }

  passwordNotSuitable(){
    let message = this.translate.instant("Password is not suitable.");
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  userNotFound(){
    let message = this.translate.instant("User not found");
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  pdfNotApplicableForSigning(){
    let message = this.translate.instant("This PDF file is not suitable for signing");
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  citizenIdNotMatch(){
    let message = this.translate.instant("Citizen ID in signature does not match");
    let subtheme = 'alert-danger';
    let sticky = true;

    this.Notification(message, subtheme, sticky);
  }

  signingBusy(){
    let message = this.translate.instant("Another signing operation is in progress");
    let subtheme = 'alert-warning';

    this.Notification(message, subtheme);
  }

  cannotDeleteOwnerRecipient(){
    let message = this.translate.instant("Cannot delete owner recipient");
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  recipientAlreadyExists(){
    let message = this.translate.instant("Recipient already exists");
    let subtheme = 'alert-warning';

    this.Notification(message, subtheme);
  }

  membershipPlanNotSuitable(){
    let message = this.translate.instant("Your membership plan does not support this feature");
    let subtheme = 'alert-warning';
    let sticky = true;

    this.Notification(message, subtheme, sticky);
  }

  documentAlreadySigned(){
    let message = this.translate.instant("Document is already signed");
    let subtheme = 'alert-warning';

    this.Notification(message, subtheme);
  }

  invalidJobIdentifier(){
    let message = this.translate.instant("Invalid document identifier");
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  publicLinkNotExist(){
    let message = this.translate.instant("No public link exists");
    let subtheme = 'alert-warning';

    this.Notification(message, subtheme);
  }

  jobStateNotSuitable(){
    let message = this.translate.instant("Document state is not suitable for this operation");
    let subtheme = 'alert-warning';

    this.Notification(message, subtheme);
  }

  jobNotFound(){
    let message = this.translate.instant("Document not found");
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  noPermission(){
    let message = this.translate.instant("You do not have permission for this action");
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  recipientNotMatch(){
    let message = this.translate.instant("You are not the recipient of this document");
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  resetCodeNotFound(){
    let message = this.translate.instant("Password reset code not found");
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  attachmentLimitExceeded(){
    let message = this.translate.instant("Maximum attachment limit (15) exceeded");
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  attachmentNotFound(){
    let message = this.translate.instant("Attachment not found");
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  attachmentAlreadyExists(){
    let message = this.translate.instant("Attachment with this name already exists");
    let subtheme = 'alert-warning';

    this.Notification(message, subtheme);
  }

  attachmentOperationFailed(){
    let message = this.translate.instant("Attachment operation failed");
    let subtheme = 'alert-danger';

    this.Notification(message, subtheme);
  }

  noAttachments(){
    let message = this.translate.instant("No attachments exist");
    let subtheme = 'alert-info';

    this.Notification(message, subtheme);
  }

  attachmentModificationNotAllowed(){
    let message = this.translate.instant("Attachments cannot be modified after signing workflow starts");
    let subtheme = 'alert-warning';

    this.Notification(message, subtheme);
  }

  showAttachmentDeleteAlert(attachmentName: string, callback: Function) {
    // HTML-encode the filename to prevent XSS via malicious filenames
    const safeDisplayName = attachmentName
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
    let title = this.translate.instant('Delete Attachment');
    let text = this.translate.instant('CONFIRM_DELETE_ATTACHMENT', { name: safeDisplayName });

    const options = {
      ...this.swalOptions,
      confirmButtonText: this.translate.instant("Delete"),
      showCancelButton: true,
      type: "warning"
    };

    this.SwalAlert(title, text, options, function(isConfirmed: boolean) { callback(isConfirmed); });
  }

  showAccessDenied(): void {
    let message = this.translate.instant("Access Denied");
    this.Notification(message, 'alert-danger', false);
  }

  // ============================================
  // New notification methods for updated error codes
  // ============================================

  invalidInput(){
    let message = this.translate.instant("Invalid input provided");
    this.Notification(message, 'alert-danger', false);
  }

  // TSA/timestamp service (TSS) unreachable during signing. Mirrors
  // invalidInput() verbatim: same banner helper, 'alert-danger', auto-dismiss.
  timestampServiceUnavailable(){
    let message = this.translate.instant("TIMESTAMP_SERVICE_UNAVAILABLE");
    this.Notification(message, 'alert-danger', false);
  }

  internalServerError(){
    let message = this.translate.instant("Internal server error occurred");
    this.Notification(message, 'alert-danger', true);
  }

  notOwner(){
    let message = this.translate.instant("You are not the owner of this resource");
    this.Notification(message, 'alert-danger', false);
  }

  cantCopyDocuments(){
    let message = this.translate.instant("Could not copy the documents");
    this.Notification(message, 'alert-danger', false);
  }

  signingFailed(){
    let message = this.translate.instant("Signing failed");
    this.Notification(message, 'alert-danger', true);
  }

  noRecipientRequest(){
    let message = this.translate.instant("No signing request exists for this code. Signer might have signed or rejected the document");
    this.Notification(message, 'alert-warning', true);
  }

  signatureIntegrityCheckFailed(){
    let message = this.translate.instant("Signature integrity check failed");
    this.Notification(message, 'alert-danger', true);
  }

  signatureNotTrusted(){
    let message = this.translate.instant("Signature is not trusted");
    this.Notification(message, 'alert-danger', true);
  }

  signatureNotValidOnSigningDate(){
    let message = this.translate.instant("Signature was not valid on signing date");
    this.Notification(message, 'alert-danger', true);
  }

  signatureTimestampNotVerified(){
    let message = this.translate.instant("Signature timestamp could not be verified");
    this.Notification(message, 'alert-warning', true);
  }

  lastSignatureIsTimestamp(){
    let message = this.translate.instant("Last signature is a timestamp");
    this.Notification(message, 'alert-info', false);
  }

  alreadyMovedToInbox(){
    let message = this.translate.instant("Document has already been moved to Inbox");
    this.Notification(message, 'alert-info', false);
  }

  alreadyMovedToArchive(){
    let message = this.translate.instant("Document has already been moved to Archive");
    this.Notification(message, 'alert-info', false);
  }

  emailAlreadyAssociated(){
    let message = this.translate.instant("This email is already associated with your account");
    this.Notification(message, 'alert-warning', false);
  }

  emailAssociationWaitingApproval(){
    let message = this.translate.instant("Email association request is pending approval");
    this.Notification(message, 'alert-info', false);
  }

  invalidAccessCode(){
    let message = this.translate.instant("Invalid or non-existent access code");
    this.Notification(message, 'alert-danger', false);
  }

  invalidParameterSorting(){
    let message = this.translate.instant("Invalid parameter sorting");
    this.Notification(message, 'alert-warning', false);
  }

  lessThanSixHours(){
    let message = this.translate.instant("Less than six hours after the last run time");
    this.Notification(message, 'alert-warning', false);
  }

  couponUsageExpired(){
    let message = this.translate.instant("Coupon usage has expired");
    this.Notification(message, 'alert-warning', false);
  }

  mobileCertificateChanged(){
    let message = this.translate.instant("Your mobile certificate has changed or been renewed. Please sign again.");
    this.Notification(message, 'alert-warning', true);
  }

  signingExpired(){
    let message = this.translate.instant("Signing has expired");
    this.Notification(message, 'alert-danger', false);
  }

  couponError(){
    let message = this.translate.instant("Coupon error or coupon not found");
    this.Notification(message, 'alert-warning', false);
  }

  waitToCompleteJobForAccesscode(){
    let message = this.translate.instant("The signing process has not yet been completed. You can view the document when the signatures are complete.");
    this.Notification(message, 'alert-info', true);
  }

  mobileTokenTimeout(){
    let message = this.translate.instant("Mobile token timed out");
    this.Notification(message, 'alert-danger', false);
  }

  sftpNotExist(){
    let message = this.translate.instant("SFTP server not found");
    this.Notification(message, 'alert-danger', false);
  }

  sftpCredentialsWrong(){
    let message = this.translate.instant("SFTP server credentials are incorrect");
    this.Notification(message, 'alert-danger', false);
  }

  sftpServerProblem(){
    let message = this.translate.instant("SFTP server error occurred");
    this.Notification(message, 'alert-danger', false);
  }

  teamRequestCancelled(){
    let message = this.translate.instant("Team request has been cancelled");
    this.Notification(message, 'alert-info', false);
  }

  teamRequestCodeUsed(){
    let message = this.translate.instant("Team request code has already been used");
    this.Notification(message, 'alert-warning', false);
  }

  smsOtpExpired(){
    let message = this.translate.instant("SMS verification code has expired");
    this.Notification(message, 'alert-danger', false);
  }

  smsOtpDoesNotMatch(){
    let message = this.translate.instant("SMS verification code does not match");
    this.Notification(message, 'alert-danger', false);
  }

  paymentNotFound(){
    let message = this.translate.instant("Payment not found");
    this.Notification(message, 'alert-danger', false);
  }

  invalidUserGroup(){
    let message = this.translate.instant("This email cannot be used");
    this.Notification(message, 'alert-danger', false);
  }

  invalidTemplate(){
    let message = this.translate.instant("Invalid template");
    this.Notification(message, 'alert-danger', false);
  }

  sftpNotAllowed(){
    let message = this.translate.instant("SFTP is not allowed for your account");
    this.Notification(message, 'alert-warning', false);
  }

  bulkSigningNotAllowed(){
    let message = this.translate.instant("Bulk signing is not allowed for your account");
    this.Notification(message, 'alert-warning', false);
  }

  apiVersionIncompatible(){
    let message = this.translate.instant("API version is incompatible");
    this.Notification(message, 'alert-danger', true);
  }

  padesCadesMixNotAllowed(){
    let message = this.translate.instant("PADES and CADES documents cannot be mixed in bulk signing");
    this.Notification(message, 'alert-danger', false);
  }

  oldNewPadesMixNotAllowed(){
    let message = this.translate.instant("Old and new version PADES documents cannot be mixed in bulk signing");
    this.Notification(message, 'alert-danger', false);
  }

  oldNewVersionMixNotAllowed(){
    let message = this.translate.instant("Old and new version documents cannot be mixed in bulk signing");
    this.Notification(message, 'alert-danger', false);
  }

  oldPadesNotSupported(){
    let message = this.translate.instant("Old version PADES documents are not supported for bulk signing");
    this.Notification(message, 'alert-danger', false);
  }

  totalPdfSizeExceeded(){
    let message = this.translate.instant("Total PDF size exceeds 150 MB limit");
    this.Notification(message, 'alert-danger', false);
  }

  signatureFieldAlreadyExists(){
    let message = this.translate.instant("Signature field already exists in document. Please contact support.");
    this.Notification(message, 'alert-danger', true);
  }

  invalidDocument(){
    let message = this.translate.instant("Invalid document identifier");
    this.Notification(message, 'alert-danger', false);
  }

  alreadyDeleted(){
    let message = this.translate.instant("Already deleted");
    this.Notification(message, 'alert-info', false);
  }

  couponDiscountExpired(){
    let message = this.translate.instant("Coupon discount has expired");
    this.Notification(message, 'alert-warning', false);
  }

  noCouponFound(){
    let message = this.translate.instant("No coupon found");
    this.Notification(message, 'alert-warning', false);
  }

  notAuthorizedToAccessJob(){
    let message = this.translate.instant('You are not authorized to access this job.');
    let subtheme = 'alert-danger';
    this.Notification(message, subtheme);
  }

}
